export default __webpack_public_path__ + "static/media/Home_page.282a582b.png";